import axios from '@/libs/axios'
import { handleCatch } from '@/utils'

export default {
  async exportMultipleChoiceExam(params) {
    try {
      const response = await axios.get('uni/qbExams/exportPdfMultipleChoiceExam', { params, responseType: 'blob' })
      if (response.status === 200) {
        return response.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
